import { render } from "./LangSwitch.vue?vue&type=template&id=124d181c"
import script from "./LangSwitch.vue?vue&type=script&lang=js"
export * from "./LangSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/LangSwitch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "124d181c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('124d181c', __exports__)) {
    api.reload('124d181c', __exports__)
  }
  
  module.hot.accept("./LangSwitch.vue?vue&type=template&id=124d181c", () => {
    api.rerender('124d181c', render)
  })

}


export default __exports__